(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-toggles"] && !Shopify.designMode) return;
  try {
    
if(!window.elarisBenefitEditorBound){
 window.elarisBenefitEditorBound=true;
 document.addEventListener('shopify:block:select',function(event){
  const block=event.target.closest('.ebt-block');
  if(block&&matchMedia('(max-width:768px)').matches){const toggle=block.querySelector('.ebt-toggle');if(toggle)toggle.open=true;}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clinician-reviews-v2"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('elaris-clinician-reviews-v2-fixed')) {
 customElements.define('elaris-clinician-reviews-v2-fixed', class extends HTMLElement {
  connectedCallback() { this.frame=requestAnimationFrame(()=>this.init()); }
  init() {
   this.controller?.abort(); this.controller=new AbortController();
   const opts={signal:this.controller.signal};
   this.track=this.querySelector('.elaris-cv2-list');
   this.cards=Array.from(this.querySelectorAll('.elaris-cv2-card'));
   this.dots=Array.from(this.querySelectorAll('[data-index]'));
   this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');
   if(!this.cards.length)return;
   this.current=0;
   const controls=this.querySelector('.elaris-cv2-controls');if(controls)controls.hidden=false;
   this.prev?.addEventListener('click',()=>this.go(this.current-1),opts);
   this.next?.addEventListener('click',()=>this.go(this.current+1),opts);
   this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>this.go(i),opts));
   this.track.addEventListener('keydown',e=>{
    if(e.target!==this.track)return;
    const rtl=getComputedStyle(this).direction==='rtl';
    let next=this.current;
    if(e.key==='ArrowRight')next+=rtl?-1:1;
    else if(e.key==='ArrowLeft')next+=rtl?1:-1;
    else if(e.key==='Home')next=0;
    else if(e.key==='End')next=this.cards.length-1;
    else return;
    e.preventDefault();this.go(next);
   },opts);
   this.track.addEventListener('touchstart',e=>{
    if(e.touches.length!==1){this.touch=null;return;}
    this.touch={x:e.touches[0].clientX,y:e.touches[0].clientY};
   },{...opts,passive:true});
   this.track.addEventListener('touchend',e=>{
    if(!this.touch)return;
    const dx=e.changedTouches[0].clientX-this.touch.x,dy=e.changedTouches[0].clientY-this.touch.y;
    this.touch=null;
    if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5){
     const rtl=getComputedStyle(this).direction==='rtl';
     this.go(this.current+(dx<0?1:-1)*(rtl?-1:1));
    }
   },{...opts,passive:true});
   this.track.addEventListener('touchcancel',()=>{this.touch=null;},opts);
   this.addEventListener('shopify:block:select',e=>{
    const i=this.cards.findIndex(c=>c.dataset.blockId===String(e.detail.blockId));if(i>=0)this.go(i);
   },opts);
   this.go(0);
  }
  go(index){
   index=Math.max(0,Math.min(index,this.cards.length-1));
   this.current=index;
   this.cards.forEach((card,i)=>{
    if(i!==index&&card.contains(document.activeElement))this.track.focus({preventScroll:true});
    card.removeAttribute('hidden');card.removeAttribute('inert');card.removeAttribute('aria-hidden');card.dataset.slideActive=String(i===index);
   });
   this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index)));
   if(this.prev)this.prev.disabled=index===0;
   if(this.next)this.next.disabled=index===this.cards.length-1;
   this.querySelector('[data-status]').textContent=this.cards[index].getAttribute('aria-label');
  }
  disconnectedCallback(){cancelAnimationFrame(this.frame);this.controller?.abort();}
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clinician-reviews-v3"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('clinician-reviews-v2')) {
  customElements.define('clinician-reviews-v2', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.crv2__track');
      this.cards = [...this.querySelectorAll('.crv2__card')];
      this.filters = [...this.querySelectorAll('[data-filter]')];
      this.selected = 'all';
      this.addEventListener('click', event => {
        const filter = event.target.closest('[data-filter]');
        if (filter && this.contains(filter)) this.filter(filter.dataset.filter);
        const arrow = event.target.closest('[data-direction]');
        if (arrow && this.contains(arrow)) this.move(Number(arrow.dataset.direction));
      }, options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') {
          const cards = this.cards.filter(card => !card.hidden);
          this.scrollToCard(event.key === 'Home' ? cards[0] : cards[cards.length - 1]);
        } else {
          const rtl = getComputedStyle(this).direction === 'rtl';
          this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }
      }, options);
      this.track.addEventListener('scroll', () => this.updateArrows(), { ...options, passive: true });
      this.observer = new ResizeObserver(() => { this.updateLayout(); this.updateArrows(); });
      this.observer.observe(this.track);
      if (this.cards[0]) this.observer.observe(this.cards[0]);
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const card = event.target.closest('.crv2__card');
        const filter = event.target.closest('[data-filter]');
        if (card) { this.filter('all'); requestAnimationFrame(() => this.scrollToCard(card, true)); }
        if (filter) { this.filter(filter.dataset.filter); filter.scrollIntoView({block:'nearest',inline:'nearest'}); }
      }, options);
      this.updateLayout();
      this.updateArrows();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
    updateLayout() {
      this.style.setProperty('--crv2-scale', '1');
    }
    filter(key) {
      this.selected = key;
      this.filters.forEach(button => {
        const active = button.dataset.filter === key;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      this.cards.forEach(card => { card.hidden = key !== 'all' && !card.dataset.category.split('|').map(value => value.trim()).includes(key); });
      const total = this.cards.filter(card => !card.hidden).length;
      this.querySelector('[data-total]').textContent = total;
      const label = this.querySelector('[data-label-one]');
      label.textContent = total === 1 ? label.dataset.labelOne : label.dataset.labelMany;
      this.querySelector('.crv2__empty').hidden = total > 0;
      this.track.scrollTo({ left: 0, behavior: 'instant' });
      requestAnimationFrame(() => { this.updateLayout(); this.updateArrows(); });
    }
    scrollToCard(card, instant = false) {
      if (!card) return;
      const rtl = getComputedStyle(this).direction === 'rtl';
      const trackRect = this.track.getBoundingClientRect();
      const rect = card.getBoundingClientRect();
      const delta = rtl ? rect.right - trackRect.right + 2 : rect.left - trackRect.left - 2;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({left: delta, behavior: instant || reduced ? 'instant' : 'smooth'});
    }
    move(direction) {
      const cards = this.cards.filter(card => !card.hidden);
      if (!cards.length) return;
      const rtl = getComputedStyle(this).direction === 'rtl';
      const edge = this.track.getBoundingClientRect();
      const distances = cards.map(card => {
        const rect = card.getBoundingClientRect();
        return Math.abs(rtl ? rect.right - edge.right + 2 : rect.left - edge.left - 2);
      });
      const index = distances.indexOf(Math.min(...distances));
      this.scrollToCard(cards[Math.max(0, Math.min(cards.length - 1, index + direction))]);
    }
    updateArrows() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const position = Math.abs(this.track.scrollLeft);
      const previous = this.querySelector('[data-direction="-1"]');
      const next = this.querySelector('[data-direction="1"]');
      if (previous) previous.disabled = position <= 5;
      if (next) next.disabled = position >= max - 5;
      this.querySelector('.crv2__window').classList.toggle('is-end', position >= max - 5);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clinician-reviews"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('elaris-clinician-reviews')) {
 customElements.define('elaris-clinician-reviews', class extends HTMLElement {
  connectedCallback() { this.frame=requestAnimationFrame(()=>this.init()); }
  init() {
   this.controller?.abort(); this.controller=new AbortController();
   const opts={signal:this.controller.signal};
   this.track=this.querySelector('.elaris-cr__track');
   this.cards=Array.from(this.querySelectorAll('.elaris-cr__card'));
   this.dots=Array.from(this.querySelectorAll('[data-index]'));
   this.prev=this.querySelector('[data-prev]'); this.next=this.querySelector('[data-next]');
   if(!this.cards.length) return;
   this.current=0;
   const controls=this.querySelector('.elaris-cr__controls'); if(controls) controls.hidden=false;
   this.prev?.addEventListener('click',()=>this.go(this.current-1),opts);
   this.next?.addEventListener('click',()=>this.go(this.current+1),opts);
   this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>this.go(i),opts));
   this.track.addEventListener('keydown',event=>{
    if(event.target!==this.track) return;
    const rtl=getComputedStyle(this.track).direction==='rtl';
    let i=this.current;
    if(event.key==='ArrowRight') i+=rtl?-1:1;
    else if(event.key==='ArrowLeft') i+=rtl?1:-1;
    else if(event.key==='Home') i=0;
    else if(event.key==='End') i=this.cards.length-1;
    else return;
    event.preventDefault();this.go(i);
   },opts);
   this.track.addEventListener('scroll',()=>{
    cancelAnimationFrame(this.scrollFrame);
    this.scrollFrame=requestAnimationFrame(()=>{
     const r=this.track.getBoundingClientRect(), center=r.left+r.width/2;
     let nearest=0,distance=Infinity;
     this.cards.forEach((card,i)=>{const b=card.getBoundingClientRect(),d=Math.abs(b.left+b.width/2-center);if(d<distance){distance=d;nearest=i;}});
     this.update(nearest);
    });
   },opts);
   this.addEventListener('shopify:block:select',event=>{
    const i=this.cards.findIndex(card=>card.dataset.blockId===String(event.detail.blockId));if(i>=0)this.go(i,false);
   },opts);
   this.observer?.disconnect();
   this.observer=new ResizeObserver(()=>this.go(this.current,false));this.observer.observe(this.track);
   this.setAttribute('data-ready','');this.go(0,false);
  }
  go(index,animate=true) {
   index=Math.max(0,Math.min(index,this.cards.length-1));
   this.update(index);
   const card=this.cards[index],r=this.track.getBoundingClientRect(),b=card.getBoundingClientRect();
   this.track.scrollBy({left:b.left+b.width/2-r.left-r.width/2,behavior:animate&&!matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'instant'});
  }
  update(index) {
   this.current=index;
   this.cards.forEach((card,i)=>{
    const active=i===index;
    if(!active&&card.contains(document.activeElement))this.track.focus({preventScroll:true});
    card.classList.toggle('is-active',active);card.inert=!active;card.setAttribute('aria-hidden',String(!active));
   });
   this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index)));
   if(this.prev)this.prev.disabled=index===0;
   if(this.next)this.next.disabled=index===this.cards.length-1;
   this.querySelector('[data-status]').textContent=this.cards[index].getAttribute('aria-label');
  }
  disconnectedCallback(){cancelAnimationFrame(this.frame);cancelAnimationFrame(this.scrollFrame);this.controller?.abort();this.observer?.disconnect();}
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clinician-reviews2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('clinician-reviews')) {
  customElements.define('clinician-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.cr__track');
      this.cards = [...this.querySelectorAll('.cr__card')];
      this.filters = [...this.querySelectorAll('[data-filter]')];
      this.selected = 'all';
      this.addEventListener('click', event => {
        const filter = event.target.closest('[data-filter]');
        if (filter && this.contains(filter)) this.filter(filter.dataset.filter);
        const arrow = event.target.closest('[data-direction]');
        if (arrow && this.contains(arrow)) this.move(Number(arrow.dataset.direction));
      }, options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') {
          const cards = this.cards.filter(card => !card.hidden);
          this.scrollToCard(event.key === 'Home' ? cards[0] : cards[cards.length - 1]);
        } else {
          const rtl = getComputedStyle(this).direction === 'rtl';
          this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }
      }, options);
      this.track.addEventListener('scroll', () => this.updateArrows(), { ...options, passive: true });
      this.observer = new ResizeObserver(() => { this.updateLayout(); this.updateArrows(); });
      this.observer.observe(this.track);
      if (this.cards[0]) this.observer.observe(this.cards[0]);
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const card = event.target.closest('.cr__card');
        const filter = event.target.closest('[data-filter]');
        if (card) { this.filter('all'); requestAnimationFrame(() => this.scrollToCard(card, true)); }
        if (filter) { this.filter(filter.dataset.filter); filter.scrollIntoView({block:'nearest',inline:'nearest'}); }
      }, options);
      this.updateLayout();
      this.updateArrows();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
    updateLayout() {
      const card = this.cards.find(item => !item.hidden);
      const mobile = matchMedia('(max-width: 749px)').matches;
      const scale = this.dataset.layout === 'adaptive' && !mobile && card
        ? Math.max(0.5, Math.min(1, card.getBoundingClientRect().width / 520)) : 1;
      this.style.setProperty('--cr-scale', String(Math.round(scale * 1000) / 1000));
    }
    filter(key) {
      this.selected = key;
      this.filters.forEach(button => {
        const active = button.dataset.filter === key;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      this.cards.forEach(card => { card.hidden = key !== 'all' && card.dataset.category !== key; });
      const total = this.cards.filter(card => !card.hidden).length;
      this.querySelector('[data-total]').textContent = total;
      const label = this.querySelector('[data-label-one]');
      label.textContent = total === 1 ? label.dataset.labelOne : label.dataset.labelMany;
      this.querySelector('.cr__empty').hidden = total > 0;
      this.track.scrollTo({ left: 0, behavior: 'instant' });
      requestAnimationFrame(() => { this.updateLayout(); this.updateArrows(); });
    }
    scrollToCard(card, instant = false) {
      if (!card) return;
      const rtl = getComputedStyle(this).direction === 'rtl';
      const trackRect = this.track.getBoundingClientRect();
      const rect = card.getBoundingClientRect();
      const delta = rtl ? rect.right - trackRect.right + 2 : rect.left - trackRect.left - 2;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({left: delta, behavior: instant || reduced ? 'instant' : 'smooth'});
    }
    move(direction) {
      const cards = this.cards.filter(card => !card.hidden);
      if (!cards.length) return;
      const rtl = getComputedStyle(this).direction === 'rtl';
      const edge = this.track.getBoundingClientRect();
      const distances = cards.map(card => {
        const rect = card.getBoundingClientRect();
        return Math.abs(rtl ? rect.right - edge.right + 2 : rect.left - edge.left - 2);
      });
      const index = distances.indexOf(Math.min(...distances));
      this.scrollToCard(cards[Math.max(0, Math.min(cards.length - 1, index + direction))]);
    }
    updateArrows() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const position = Math.abs(this.track.scrollLeft);
      const previous = this.querySelector('[data-direction="-1"]');
      const next = this.querySelector('[data-direction="1"]');
      if (previous) previous.disabled = position <= 5;
      if (next) next.disabled = position >= max - 5;
      this.querySelector('.cr__window').classList.toggle('is-end', position >= max - 5);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elaris-dynamic-faq')) {
    customElements.define('elaris-dynamic-faq', class extends HTMLElement {
      connectedCallback() {
        // Wait until children exist, including when Theme Editor inserts a new instance.
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        // The root ID and all button/panel IDs include Shopify's section.id.
        if (this.id !== 'FAQ-' + this.dataset.sectionId) return;
        const rows = Array.from(this.querySelectorAll('[data-faq-row]'));
        this.removeAttribute('data-ready');
        rows.forEach((row, index) => {
          const button = row.querySelector('.faq-trigger');
          this.setOpen(row, index === 0 && this.dataset.firstOpen === 'true');
          button.disabled = false;
          button.addEventListener('click', () => {
            this.setOpen(row, button.getAttribute('aria-expanded') !== 'true');
          }, options);
        });
        this.setAttribute('data-ready', '');
        this.addEventListener('shopify:block:select', (event) => {
          const row = rows.find(item => item.dataset.blockId === String(event.detail.blockId));
          if (row) this.setOpen(row, true);
        }, options);
      }
      setOpen(row, open) {
        const button = row.querySelector('.faq-trigger');
        const panel = row.querySelector('.faq-body');
        if (!open && panel.contains(document.activeElement)) button.focus();
        button.setAttribute('aria-expanded', String(open));
        panel.setAttribute('aria-hidden', String(!open));
        // Remove collapsed rich-text links from keyboard focus and the accessibility tree.
        panel.inert = !open;
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.controller) this.controller.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-timeline-duo"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elaris-results-timeline-duo'))customElements.define('elaris-results-timeline-duo',class extends HTMLElement{
 connectedCallback(){this.frame=requestAnimationFrame(()=>this.init());}
 init(){
  this.controller?.abort();this.controller=new AbortController();const opts={signal:this.controller.signal};
  this.cards=Array.from(this.querySelectorAll('[data-stage]'));this.current=0;this.media=matchMedia('(max-width:900px)');
  this.track=this.querySelector('.ert-stages');this.dots=Array.from(this.querySelectorAll('[data-index]'));this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');
  if(!this.cards.length)return;
  this.prev?.addEventListener('click',()=>this.go(this.current-1),opts);this.next?.addEventListener('click',()=>this.go(this.current+1),opts);
  this.dots.forEach((b,i)=>b.addEventListener('click',()=>this.go(i),opts));
  this.stageLinks=Array.from(this.querySelectorAll('[data-stage-link]'));
  this.stageLinks.forEach((b,i)=>b.addEventListener('click',()=>this.go(i),opts));
  this.track.addEventListener('keydown',e=>{if(e.target!==this.track)return;let n=this.current;const rtl=getComputedStyle(this).direction==='rtl';if(e.key==='ArrowRight')n+=rtl?-1:1;else if(e.key==='ArrowLeft')n+=rtl?1:-1;else if(e.key==='Home')n=0;else if(e.key==='End')n=this.cards.length-1;else return;e.preventDefault();this.go(n);},opts);
  this.track.addEventListener('touchstart',e=>{this.touch=e.touches.length===1?{x:e.touches[0].clientX,y:e.touches[0].clientY}:null;},{...opts,passive:true});
  this.track.addEventListener('touchend',e=>{if(!this.touch)return;const dx=e.changedTouches[0].clientX-this.touch.x,dy=e.changedTouches[0].clientY-this.touch.y;this.touch=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5)this.go(this.current+(dx<0?1:-1)*(getComputedStyle(this).direction==='rtl'?-1:1));},{...opts,passive:true});
  this.track.addEventListener('touchcancel',()=>this.touch=null,opts);
  this.media.addEventListener('change',()=>this.go(this.current),opts);
  this.addEventListener('shopify:block:select',e=>{const i=this.cards.findIndex(c=>c.dataset.blockId===String(e.detail.blockId));if(i>=0)this.go(i);},opts);
  this.setAttribute('data-ready','');this.go(0);
 }
 go(i){
  const count=this.media.matches?1:2;
  const maximum=Math.max(0,this.cards.length-count);
  this.current=Math.max(0,Math.min(i,maximum));
  this.cards.forEach((c,n)=>{
   const visible=n>=this.current&&n<this.current+count;
   if(!visible&&c.contains(document.activeElement))this.track.focus({preventScroll:true});
   c.dataset.visible=String(visible);
  });
  this.dots.forEach((b,n)=>{b.hidden=n>maximum;b.setAttribute('aria-current',String(n===this.current));});
  if(this.prev)this.prev.disabled=this.current===0;
  if(this.next)this.next.disabled=this.current===maximum;
  const controls=this.querySelector('.ert-controls');if(controls)controls.hidden=maximum===0;
  this.stageLinks?.forEach((b,n)=>{const visible=n>=this.current&&n<this.current+count;b.dataset.visible=String(visible);if(n===this.current)b.setAttribute('aria-current','step');else b.removeAttribute('aria-current');});
  const labels=this.cards.slice(this.current,this.current+count).map(c=>c.querySelector('.ert-time').textContent.trim());
  this.querySelector('[data-status]').textContent=labels.join(' / ');
 }

 disconnectedCallback(){cancelAnimationFrame(this.frame);this.controller?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-timeline"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elaris-results-timeline'))customElements.define('elaris-results-timeline',class extends HTMLElement{
 connectedCallback(){this.frame=requestAnimationFrame(()=>this.init());}
 init(){
  this.controller?.abort();this.controller=new AbortController();const opts={signal:this.controller.signal};
  this.cards=Array.from(this.querySelectorAll('[data-stage]'));this.current=0;this.media=matchMedia('(max-width:900px)');
  this.track=this.querySelector('.ert-stages');this.dots=Array.from(this.querySelectorAll('[data-index]'));this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');
  if(!this.cards.length)return;
  this.prev?.addEventListener('click',()=>this.go(this.current-1),opts);this.next?.addEventListener('click',()=>this.go(this.current+1),opts);
  this.dots.forEach((b,i)=>b.addEventListener('click',()=>this.go(i),opts));
  this.track.addEventListener('keydown',e=>{if(!this.media.matches||e.target!==this.track)return;let n=this.current;const rtl=getComputedStyle(this).direction==='rtl';if(e.key==='ArrowRight')n+=rtl?-1:1;else if(e.key==='ArrowLeft')n+=rtl?1:-1;else if(e.key==='Home')n=0;else if(e.key==='End')n=this.cards.length-1;else return;e.preventDefault();this.go(n);},opts);
  this.track.addEventListener('touchstart',e=>{this.touch=e.touches.length===1?{x:e.touches[0].clientX,y:e.touches[0].clientY}:null;},{...opts,passive:true});
  this.track.addEventListener('touchend',e=>{if(!this.touch||!this.media.matches)return;const dx=e.changedTouches[0].clientX-this.touch.x,dy=e.changedTouches[0].clientY-this.touch.y;this.touch=null;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5)this.go(this.current+(dx<0?1:-1)*(getComputedStyle(this).direction==='rtl'?-1:1));},{...opts,passive:true});
  this.track.addEventListener('touchcancel',()=>this.touch=null,opts);
  this.media.addEventListener('change',()=>this.go(this.current),opts);
  this.addEventListener('shopify:block:select',e=>{const i=this.cards.findIndex(c=>c.dataset.blockId===String(e.detail.blockId));if(i>=0)this.go(i);},opts);
  this.setAttribute('data-ready','');this.go(0);
 }
 go(i){this.current=Math.max(0,Math.min(i,this.cards.length-1));this.cards.forEach((c,n)=>{if(this.media.matches&&n!==this.current&&c.contains(document.activeElement))this.track.focus({preventScroll:true});c.dataset.active=String(n===this.current);});this.dots.forEach((b,n)=>b.setAttribute('aria-current',String(n===this.current)));if(this.prev)this.prev.disabled=this.current===0;if(this.next)this.next.disabled=this.current===this.cards.length-1;this.querySelector('[data-status]').textContent=this.media.matches?this.cards[this.current].querySelector('.ert-time').textContent:'';}
 disconnectedCallback(){cancelAnimationFrame(this.frame);this.controller?.abort();}
});

  } catch(e) { console.error(e); }
})();
})();
